import PublicImage from '@/components/PublicImage/PublicImage'

interface Props {
  width?: string
  height?: string
}

export default function ShwLogo({ width, height }: Props) {
  return <PublicImage src="/logo-small-v3.svg" width={width} height={height} />
}
